import React, { useState, useEffect } from 'react';
import Tabs from '../../UI/Tabs/Tabs';
import classes from './TabsWrapper.module.css';

const TabsWrapper = ({
  withRouting,
  match,
  tabRoutes,
  activeTab: initialActiveTab,
  history,
  setActiveTab,
  tabNavTitles,
  components,
  dots,
  squared,
  tabsNavWrapperStyle,
  tabsNavStyle,
  style,
}) => {
  const [activeTab, setActiveTabState] = useState(0);
  const [currentRoute, setCurrentRoute] = useState('');
  const [historyPushed, setHistoryPushed] = useState(false);

  // Handle initialization when component mounts
  useEffect(() => {
    if (withRouting && match) {
      const index = tabRoutes.findIndex((route) => route === match.url);
      setActiveTabState(index !== -1 ? index : 0);
      setCurrentRoute(match.url);
    } else {
      setActiveTabState(initialActiveTab || 0);
    }
  }, [withRouting, match, tabRoutes, initialActiveTab]);

  // Handle route updates
  useEffect(() => {
    if (withRouting && match && match.params) {
      const index = tabRoutes.findIndex((route) => route === match.url);
      setActiveTabState(index !== -1 ? index : 0);
      setCurrentRoute(match.url);
    }
  }, [withRouting, match, tabRoutes]);

  const onTabClick = (idx) => {
    if (withRouting) {
      if (currentRoute !== tabRoutes[idx]) {
        if (historyPushed) {
          history.replace(tabRoutes[idx]);
        } else {
          setHistoryPushed(true);
          history.push(tabRoutes[idx]);
        }
        setActiveTabState(idx);
        setCurrentRoute(tabRoutes[idx]);
      }
    } else {
      if (setActiveTab && typeof setActiveTab === 'function') {
        setActiveTab(idx);
      }
      setActiveTabState(idx);
    }
  };

  return (
    <div className={classes.TabsWrapper} style={style}>
      <Tabs
        onTabClick={onTabClick}
        tabNavTitles={tabNavTitles}
        activeTab={activeTab}
        components={components}
        dots={dots}
        squared={squared}
        tabsNavWrapperStyle={tabsNavWrapperStyle}
        tabsNavStyle={tabsNavStyle}
      />
    </div>
  );
};

export default TabsWrapper;
